module.exports = __webpack_public_path__ + "img/windmill.f50b5cd9.png";